import React from 'react';
import Icon from '../Icon/Icon';

const GenericError = () => {
  return (
    <div className="ds-msg-summary ds-msg-summary--error ds-m-b-lg">
      <div className="ds-msg-summary__header">
        <Icon iconName="general-warning-triangle" className="ds-msg-summary__icon" />
        <h3 className="ds-msg-summary__title">There is a problem</h3>
      </div>

      <div className="ds-msg-summary__info">Please check your answers again.</div>
    </div>
  );
};

export default GenericError;
